module.exports = __webpack_public_path__ + "static/img/iphone-new-cleaned-up.c5968c0.png";